var dataStore = {
    created() {
        this.$on('toggleModalWindow', (val) => this.modalWindowOpen = val)
        document.addEventListener('keyup', function(event) {
            console.log(event.keyCode)
            switch (event.keyCode) {
                case 27: // esc
                    window.close()
                break;
            }
        })
    },
    data: {

        aspectRatio: 3954/1668,

        autoChangeDelay: 2000,
        modalWindowOpen: false,

        viewWindow: {
            width: null,
            height: null,
        },

        scenarioText: { // DONE
            fob: {
                title: 'Forward operating&nbsp;base',
                cover: 'Explore the options for a small elite team carrying equipment into difficult terrain – jungle or subarctic.',
            },
            hq: {
                title: 'Headquarters',
                cover: 'Examine the scenarios for bigger missions with equipment delivered by trucks or aircraft.',
            },
            air: {
                title: 'Deployable airbase',
                cover: "See how an airbase with air defence and communications is set up in as little as 24 hours if there's flat land for an airstrip.",
                // cover: 'See how a fully functioning airbase including integrated air defence and communications can be set up in as little as 24 hours provided there is flat land for an airstrip.',
            },

            drug_enforcement: {
                title: "Drug enforcement",
                subtitle: "Forward operating base",
                menu_subtitle: 'Jungle terrain',
                splash: {
                    content: "A discreet taskforce of up to 20 personnel are dropped with their own equipment into a remote jungle to tackle a drug trafficking operation. They can set up the FOB in as little as two hours.",
                    bgImage: "drug_enforcement-detail.jpg",
                },
                stage_1: {
                    StageNumber: "Stage one",
                    StageDesc: "An anti-drugs mission deploys in the jungle, with up to 20 personnel and equipment dropped off by&nbsp;helicopters.",
                    prevRoute: "splash",
                    nextRoute: "stage-2",
                    nextLabel: "Stage two",
                },
                stage_2: {
                    StageNumber: "Stage two",
                    StageDesc: "Team sets up tents and DCIS communications equipment in under two&nbsp;hours.",
                    prevRoute: "stage-1",
                    nextRoute: "stage-3",
                    nextLabel: "Stage three",
                },
                stage_3: {
                    StageNumber: "Stage three",
                    StageDesc: "Masts and antennas are&nbsp;erected.",
                    prevRoute: "stage-2",
                    nextRoute: "stage-4",
                    nextLabel: "Stage four",
                },
                stage_4: {
                    StageNumber: "Stage four",
                    StageDesc: "Satellite system is&nbsp;erected.",
                    prevRoute: "stage-3",
                    nextRoute: "stage-5",
                    nextLabel: "Stage five",
                },
                stage_5: {
                    StageNumber: "Stage five",
                    StageDesc: "Generators are deployed and DCIS communications equipment is&nbsp;connected.",
                    prevRoute: "stage-4",
                    nextRoute: "stage-6",
                    nextLabel: "Stage six",
                },
                stage_6: {
                    StageNumber: "Stage six",
                    StageDesc: "Mission communication begins between special forces, helicopters and&nbsp;HQ.",
                    prevRoute: "stage-4",
                    nextRoute: "splash",
                    nextLabel: "Scenario home",
                },
            },
            expeditionary: {
                title: "Expeditionary",
                subtitle: "Forward operating base",
                menu_subtitle: 'Subarctic terrain',
                splash: {
                    content: `
                        <p>Up to 20 special forces personnel drive to a remote subarctic location where they can set up an FOB ahead of a larger force.</p>
                        <p>The base will be 100% self&#8209;sustainable for the mission duration.</p>
                        `,
                    bgImage: "expeditionary-detail.jpg",
                },
                stage_1: {
                    StageNumber: "Stage one",
                    StageDesc: "An FOB mission team deploys in the subarctic. Twenty personnel in jeeps, HMMWV and trucks carry in&nbsp;equipment.",
                    prevRoute: "splash",
                    nextRoute: "stage-2",
                    nextLabel: "Stage two",
                },
                stage_2: {
                    StageNumber: "Stage two",
                    StageDesc: "Team sets up tents and DCIS communication equipment in under two&nbsp;hours.",
                    prevRoute: "stage-1",
                    nextRoute: "stage-3",
                    nextLabel: "Stage three",
                },
                stage_3: {
                    StageNumber: "Stage three",
                    StageDesc: "Masts and antennas are&nbsp;erected.",
                    prevRoute: "stage-2",
                    nextRoute: "stage-4",
                    nextLabel: "Stage four",
                },
                stage_4: {
                    StageNumber: "Stage four",
                    StageDesc: "Generators and DCIS communication equipment are&nbsp;connected.",
                    prevRoute: "stage-3",
                    nextRoute: "stage-5",
                    nextLabel: "Stage five",
                },
                stage_5: {
                    StageNumber: "Stage five",
                    StageDesc: "Satellite communication is&nbsp;connected.",
                    prevRoute: "stage-4",
                    nextRoute: "stage-6",
                    nextLabel: "Stage six",
                },
                stage_6: {
                    StageNumber: "Stage six",
                    StageDesc: "Mission communication begins between special forces, helicopters and&nbsp;HQ.",
                    prevRoute: "stage-5",
                    nextRoute: "splash",
                    nextLabel: "Scenario home",
                },
            },
            disaster_relief: {
                title: "Disaster relief",
                subtitle: "Headquarters",
                menu_subtitle: 'Barren terrain',
                splash: {
                    content: "A major humanitarian disaster is unfolding in an inhospitable climate. Up to 280 international civil personnel begin a long-term operation. A DCIS headquarters solution can be set up in under 24 hours and provides an environment that feels like home base.",
                    bgImage: "disaster_relief-detail.jpg",
                },
                stage_1: {
                    StageNumber: "Stage one",
                    StageDesc: "A 280-strong aid team deploys in a disaster zone. Trucks deliver base components and&nbsp;equipment.",
                    prevRoute: "splash",
                    nextRoute: "stage-2",
                    nextLabel: "Stage two",
                },
                stage_2: {
                    StageNumber: "Stage two",
                    StageDesc: "Team sets up containerised shelters and tents around existing barn&nbsp;structures.",
                    prevRoute: "stage-1",
                    nextRoute: "stage-3",
                    nextLabel: "Stage three",
                },
                stage_3: {
                    StageNumber: "Stage three",
                    StageDesc: "Satellite dishes, generators and antennas are&nbsp;erected.",
                    prevRoute: "stage-2",
                    nextRoute: "stage-4",
                    nextLabel: "Stage four",
                },
                stage_4: {
                    StageNumber: "Stage four",
                    StageDesc: "DCIS communications equipment is&nbsp;connected.",
                    // StageDesc: "DCIS products for HQ setup are&nbsp;connected.",
                    prevRoute: "stage-3",
                    nextRoute: "stage-5",
                    nextLabel: "Stage five",
                },
                stage_5: {
                    StageNumber: "Stage five",
                    StageDesc: "High-capability SatCom communications&nbsp;begin.",
                    prevRoute: "stage-4",
                    nextRoute: "splash",
                    nextLabel: "Scenario home",
                },
            },
            military_base: {
                title: "Military base",
                subtitle: "Headquarters",
                menu_subtitle: 'Forest terrain',
                splash: {
                    content: `
                        <p>A military force is deployed in a remote forest and sets up its communications base in less than 24 hours, with equipment delivered by trucks.</p>
                        <p>This base for up to 280 people is designed to feel like home base. It has the capability to act as an independent HQ as well as a forward HQ.</p>
                    `,
                    bgImage: "military_base-detail.jpg",
                },
                stage_1: {
                    StageNumber: "Stage one",
                    StageDesc: "A military team of up to 280 personnel deploys to a remote forest. Trucks deliver base components and&nbsp;equipment.",
                    prevRoute: "splash",
                    nextRoute: "stage-2",
                    nextLabel: "Stage two",
                },
                stage_2: {
                    StageNumber: "Stage two",
                    StageDesc: "Team sets up containerised&nbsp;shelters.",
                    prevRoute: "stage-1",
                    nextRoute: "stage-3",
                    nextLabel: "Stage three",
                },
                stage_3: {
                    StageNumber: "Stage three",
                    StageDesc: "Satellite dishes, generators and antennas are&nbsp;erected.",
                    prevRoute: "stage-2",
                    nextRoute: "stage-4",
                    nextLabel: "Stage four",
                },
                stage_4: {
                    StageNumber: "Stage four",
                    StageDesc: "DCIS products for HQ setup are&nbsp;connected.",
                    prevRoute: "stage-3",
                    nextRoute: "stage-5",
                    nextLabel: "Stage five",
                },
                stage_5: {
                    StageNumber: "Stage five",
                    StageDesc: "Communication for the mission duration is&nbsp;established.",
                    prevRoute: "stage-4",
                    nextRoute: "splash",
                    nextLabel: "Scenario home",
                },
            },
            airbase: {
                title: "Airbase",
                subtitle: "Deployable airbase",
                menu_inner: [
                    // 'See how a fully functioning airbase can be set up in as little as 24 hours with integrated air defence and communications, provided there is a potential airstrip.',
                    'See how a fully functioning airbase including integrated air defence and communications can be set up in as little as 24 hours provided there is flat land for an airstrip.',
                    'This airbase can be used tactically, strategically or as a backup airport. It can provide mission support systems and civil, military and tactical radio communications for international endeavours, as well as ATS services and deployable landing/runway light pods.',
                ],
                splash: {
                    content: "A team of civil, military or tactical international personnel can assemble an airbase, including integrated air defence and communications in the desert in as little as 24 hours, provided there is flat land for an airstrip.",
                    bgImage: "airbase-detail.jpg",
                },
                stage_1: {
                    StageNumber: "Stage one",
                    StageDesc: "A tactical team of up to 280 people deploys in the desert. Trucks deliver base components and&nbsp;equipment.",
                    prevRoute: "splash",
                    nextRoute: "stage-2",
                    nextLabel: "Stage two",
                },
                stage_2: {
                    StageNumber: "Stage two",
                    StageDesc: "Containerised shelters are&nbsp;erected.",
                    prevRoute: "stage-1",
                    nextRoute: "stage-3",
                    nextLabel: "Stage three",
                },
                stage_3: {
                    StageNumber: "Stage three",
                    StageDesc: "Control tower, satellite dishes, generators and antennas are&nbsp;installed.",
                    prevRoute: "stage-2",
                    nextRoute: "stage-4",
                    nextLabel: "Stage four",
                },
                stage_4: {
                    StageNumber: "Stage four",
                    StageDesc: "DCIS communications equipment is connected for mission&nbsp;duration.",
                    prevRoute: "stage-3",
                    nextRoute: "stage-5",
                    nextLabel: "Stage five",
                },
                stage_5: {
                    StageNumber: "Stage five",
                    StageDesc: "Team builds Saab Deployable Aircraft Maintenance Facility (DAM).",
                    prevRoute: "stage-4",
                    nextRoute: "stage-6",
                    nextLabel: "Stage six",
                },
                stage_6: {
                    StageNumber: "Stage six",
                    StageDesc: "Air-traffic control communications allow aircraft to&nbsp;land.",
                    prevRoute: "stage-5",
                    nextRoute: "splash",
                    nextLabel: "Scenario home",
                },
            },
        },

        // === === === === === === === === === === === === BACKGROUNDS

        scenarioBg: {
            drug_enforcement: { // PENDING UPDATES FROM MATT
                stage_1: [
                    "drug_enforcement-stage_1.1.jpg",
                    "drug_enforcement-stage_1.2.jpg",
                    "drug_enforcement-stage_1.3.jpg",
                    "drug_enforcement-stage_1.4.jpg",
                    "drug_enforcement-stage_1.5.jpg",
                ],
                stage_2: [
                    "drug_enforcement-stage_1.5.jpg",
                    "drug_enforcement-stage_2.1.jpg",
                    "drug_enforcement-stage_2.2.jpg",
                    "drug_enforcement-stage_2.3.jpg",
                    "drug_enforcement-stage_2.4.jpg",
                    "drug_enforcement-stage_2.5.jpg",
                    "drug_enforcement-stage_2.6.jpg",
                ],
                stage_3: [
                    "drug_enforcement-stage_2.6.jpg",
                    "drug_enforcement-stage_3.1.jpg",
                    "drug_enforcement-stage_3.2.jpg",
                ],
                stage_4: [
                    "drug_enforcement-stage_3.2.jpg",
                    'drug_enforcement-stage_4.1.jpg',
                    'drug_enforcement-stage_4.2.jpg',
                ],
                stage_5: [
                    'drug_enforcement-stage_4.2.jpg',
                    'drug_enforcement-stage_5.1.jpg',
                    'drug_enforcement-stage_5.2.jpg',
                    'drug_enforcement-stage_5.3.jpg',
                    'drug_enforcement-stage_5.4.jpg',
                ],
                stage_6: [
                    'drug_enforcement-stage_6.jpg',
                ],
            },
            expeditionary: { // DONE
                stage_1: [
                    'expeditionary-stage_1.1.jpg',
                    'expeditionary-stage_1.2.jpg',
                    'expeditionary-stage_1.3.jpg',
                    'expeditionary-stage_1.4.jpg',
                    'expeditionary-stage_1.5.jpg',
                ],
                stage_2: [
                    'expeditionary-stage_2.1.jpg',
                    'expeditionary-stage_2.2.jpg',
                    'expeditionary-stage_2.3.jpg',
                    'expeditionary-stage_2.4.jpg',
                    'expeditionary-stage_2.5.jpg',
                    'expeditionary-stage_2.6.jpg',
                    'expeditionary-stage_2.7.jpg',
                    'expeditionary-stage_2.8.jpg',
                ],
                stage_3: [
                    'expeditionary-stage_2.8.jpg',
                    'expeditionary-stage_3.1.jpg',
                    'expeditionary-stage_3.2.jpg',
                ],
                stage_4: [
                    'expeditionary-stage_4.1.jpg',
                    'expeditionary-stage_4.2.jpg',
                    'expeditionary-stage_4.3.jpg',
                    'expeditionary-stage_4.4.jpg',
                ],
                stage_5: [
                    'expeditionary-stage_4.4.jpg',
                    'expeditionary-stage_5.1.jpg',
                    'expeditionary-stage_5.2.jpg',
                ],
                stage_6: [
                    'expeditionary-stage_6.jpg',
                ],
            },
            military_base: { // DONE
                stage_1: [
                    'military_hq-stage_1.1.jpg',
                    'military_hq-stage_1.2.jpg',
                    'military_hq-stage_1.3.jpg',
                    'military_hq-stage_1.4.jpg',
                    'military_hq-stage_1.5.jpg',
                ],
                stage_2: [
                    'military_hq-stage_1.5.jpg',
                    'military_hq-stage_2.1.jpg',
                    'military_hq-stage_2.2.jpg',
                    'military_hq-stage_2.3.jpg',
                    'military_hq-stage_2.4.jpg',
                    'military_hq-stage_2.5.jpg',
                ],
                stage_3: [
                    'military_hq-stage_2.5.jpg',
                    'military_hq-stage_3.1.jpg',
                    'military_hq-stage_3.2.jpg',
                    'military_hq-stage_3.3.jpg',
                    'military_hq-stage_3.4.jpg',
                    'military_hq-stage_3.5.jpg',
                    'military_hq-stage_3.6.jpg',
                ],
                stage_4: [
                    'military_hq-stage_3.6.jpg',
                    'military_hq-stage_4.1.jpg',
                    'military_hq-stage_4.2.jpg',
                ],
                stage_5: [
                    'military_hq-stage_5.jpg',
                ],


            },
            disaster_relief: { // DONE
                stage_1: [
                    'disaster_relief-stage_1.1.jpg',
                    'disaster_relief-stage_1.2.jpg',
                    'disaster_relief-stage_1.3.jpg',
                    'disaster_relief-stage_1.4.jpg',
                    'disaster_relief-stage_1.5.jpg',
                ],
                stage_2: [
                    'disaster_relief-stage_1.5.jpg',
                    'disaster_relief-stage_2.1.jpg',
                    'disaster_relief-stage_2.2.jpg',
                    'disaster_relief-stage_2.3.jpg',
                    'disaster_relief-stage_2.4.jpg',
                    'disaster_relief-stage_2.5.jpg',
                    'disaster_relief-stage_2.6.jpg',
                    'disaster_relief-stage_2.7.jpg',
                ],
                stage_3: [
                    'disaster_relief-stage_2.7.jpg',
                    'disaster_relief-stage_3.1.jpg',
                    'disaster_relief-stage_3.2.jpg',
                    'disaster_relief-stage_3.3.jpg',
                    'disaster_relief-stage_3.4.jpg',
                    'disaster_relief-stage_3.5.jpg',
                    'disaster_relief-stage_3.6.jpg',
                ],
                stage_4: [
                    'disaster_relief-stage_3.6.jpg',
                    'disaster_relief-stage_4.1.jpg',
                    'disaster_relief-stage_4.2.jpg',
                ],
                stage_5: [
                    'disaster_relief-stage_5.jpg',
                ],
            },
            airbase: { // DONE
                stage_1: [
                    // "airbase-stage_1.1.jpg",
                    "airbase-stage_1.2.jpg",
                    "airbase-stage_1.3.jpg",
                    "airbase-stage_1.4.jpg",
                    "airbase-stage_1.5.jpg",
                ],
                stage_2: [
                    "airbase-stage_2.1.jpg",
                    "airbase-stage_2.2.jpg",
                    "airbase-stage_2.3.jpg",
                ],
                stage_3: [
                    "airbase-stage_2.3.jpg",
                    "airbase-stage_3.1.jpg",
                    "airbase-stage_3.2.jpg",
                    'airbase-stage_3.3.jpg',
                    'airbase-stage_3.4.jpg',
                    'airbase-stage_3.5.jpg',
                    'airbase-stage_3.6.jpg',
                ],
                stage_4: [
                    'airbase-stage_4.jpg',
                ],
                stage_5: [
                    'airbase-stage_5.1.jpg',
                    'airbase-stage_5.2.jpg',
                    'airbase-stage_5.3.jpg',
                ],
                stage_6: [
                    'airbase-stage_5.3.jpg',
                    'airbase-stage_6.1.jpg',
                    'airbase-stage_6.2.jpg',
                    'airbase-stage_6.3.jpg',
                    'airbase-stage_6.4.jpg',
                    'airbase-stage_6.5.jpg',
                    'airbase-stage_6.6.jpg',
                ],
            },
        },

        // === === === === === === === === === === === === STATS

        scenarioStats: { // DONE
            drug_enforcement: [
                {
                    icon: "images/stats_icons/time.svg",
                    title: 'Deployment time',
                    text: 'Under two hours',
                },
                {
                    icon: "images/stats_icons/truck.svg",
                    title: 'Transport',
                    text: 'Two helicopters',
                },
                {
                    icon: "images/stats_icons/environment.svg",
                    title: 'Environment',
                    text: 'Tents or existing structures',
                },
                {
                    icon: "images/stats_icons/endurance.svg",
                    // title: 'Expeditionary',
                    title: 'Site endurance',
                    text: '100% self-sustainable for the mission duration',
                },
                {
                    icon: "images/stats_icons/team.svg",
                    title: 'Team',
                    text: 'Up to 20 personnel',
                },
                {
                    icon: "images/stats_icons/comms.svg",
                    title: 'Comms',
                    text: [
                        'Between ground force and helicopters',
                        'Low bandwidth data SatCom to HQ',
                    ]
                },
            ],
            expeditionary: [
                {
                    icon: "images/stats_icons/time.svg",
                    title: 'Deployment time',
                    text: 'Up to two hours',
                },
                {
                    icon: "images/stats_icons/truck.svg",
                    title: 'Transport',
                    text: 'Jeeps, trucks and HMMWV',
                },
                {
                    icon: "images/stats_icons/environment.svg",
                    title: 'Environment',
                    text: 'Tents or existing structures',
                },
                {
                    icon: "images/stats_icons/endurance.svg",
                    title: 'Site endurance',
                    text: '14 days',
                },
                {
                    icon: "images/stats_icons/team.svg",
                    title: 'Team',
                    text: '20 personnel',
                },
                {
                    icon: "images/stats_icons/comms.svg",
                    title: 'Comms',
                    text: [
                        'Between tactical ground team and vehicles',
                        'Low bandwidth data SatCom to HQ',
                    ],
                },
            ],
            military_base: [
                {
                    icon: "images/stats_icons/time.svg",
                    title: 'Deployment time',
                    text: 'Up to 24 hours',
                },
                {
                    icon: "images/stats_icons/truck.svg",
                    title: 'Transport',
                    text: 'Trucks',
                },
                {
                    icon: "images/stats_icons/endurance.svg",
                    title: 'Site endurance',
                    text: 'Six months',
                },
                {
                    icon: "images/stats_icons/team.svg",
                    title: 'Team',
                    text: '280 personnel',
                },
                {
                    icon: "images/stats_icons/environment.svg",
                    title: 'Environment',
                    text: 'Expandable containers, shelters and tents',
                },
                {
                    icon: "images/stats_icons/comms.svg",
                    title: 'Comms',
                    text: [
                        'Ground comms between team and aircraft',
                        'High-bandwidth data SatCom to HQ',
                    ],
                },
            ],
            disaster_relief: [
                {
                    icon: "images/stats_icons/time.svg",
                    title: 'Deployment time',
                    text: 'Up to 24 hours',
                },
                {
                    icon: "images/stats_icons/truck.svg",
                    title: 'Transport',
                    text: 'Trucks, transport aircraft (e.g. C-130s and C17s)',
                },
                {
                    icon: "images/stats_icons/endurance.svg",
                    title: 'Site endurance',
                    text: 'Six months',
                },
                {
                    icon: "images/stats_icons/team.svg",
                    title: 'Team',
                    text: 'Up to 280 personnel',
                },
                {
                    icon: "images/stats_icons/environment.svg",
                    title: 'Environment',
                    text: 'Expandable container shelters and tents',
                },
                {
                    icon: "images/stats_icons/comms.svg",
                    title: 'Comms',
                    text: [
                        'Between ground force and aircraft',
                        'High-bandwidth data SatCom to HQ',
                    ],
                },
            ],
            airbase: [
                {
                    icon: "images/stats_icons/time.svg",
                    title: 'Deployment time',
                    text: '24–36 hours<br>(up to 48 hours with DAM hangars)',
                },
                {
                    icon: "images/stats_icons/truck.svg",
                    title: 'Transport',
                    text: 'Trucks, transport aircraft (e.g. C-130s and C17s)',
                },
                {
                    icon: "images/stats_icons/team.svg",
                    title: 'Team',
                    text: 'Up to 280 personnel',
                },
                {
                    icon: "images/stats_icons/environment.svg",
                    title: 'Environment',
                    text: 'Tarmac airstrip, any climate shelters, expandable shelters, tents and existing structures',
                },
                {
                    icon: "images/stats_icons/air_traffic_control.svg",
                    title: 'Air Traffic Control capacity',
                    text: '30 movements per hour',
                },
                {
                    icon: "images/stats_icons/aircraft.svg",
                    title: 'Aircraft',
                    text: 'Any, including Gripen',
                },
                {
                    icon: "images/stats_icons/endurance.svg",
                    title: 'Site endurance',
                    text: '12 months or more',
                },
                {
                    icon: "images/stats_icons/comms.svg",
                    title: 'Comms',
                    text: [
                        'On ground and with all aircraft',
                        'High-bandwidth data SatCom to HQ',
                    ],
                },
            ],
        },

        // === === === === === === === === === === === === GALLERY

        scenarioGallery: { // DONE
            drug_enforcement: [
                'drug_enforcement-gallery-1.jpg',
            ],
            expeditionary: [
                'expeditionary-gallery-1.jpg', 
                'expeditionary-gallery-2.jpg',
            ],
            military_base: [
                'military_base-gallery-1.jpg',
                'military_base-gallery-2.jpg',
                'military_base-gallery-3.jpg',
                'military_base-gallery-4.jpg',
                'military_base-gallery-5.jpg',
                'military_base-gallery-6.jpg',
            ],
            disaster_relief: [
                'disaster_relief-gallery-1.jpg',
                'disaster_relief-gallery-2.jpg',
                'disaster_relief-gallery-3.jpg',
            ],
            airbase: [
                'airbase-gallery-1.jpg', 
                'airbase-gallery-2.jpg', 
                'airbase-gallery-3.jpg', 
                'airbase-gallery-4.jpg', 
                'airbase-gallery-5.jpg', 
                'airbase-gallery-6.jpg', 
            ],
        },

        // === === === === === === === === === === === === HOTSPOTS

        scenarioHotspotButtons: {
            drug_enforcement: [
                '1.1',
                '2.1',
                '3.1',
                '4',
            ],
            expeditionary: [
                '1',
                '2.1',
                '3.1',
                '4',
                '5',
                '6.1',
            ],
            military_base: [
                '1.1',
                '2.1',
                '3',
                '4.1',
                '5',
                '6',
                '7.1',
            ],
            disaster_relief: [
                '1',
                '2',
                '3.1',
                '4',
                '5',
            ],
            airbase: [
                '1.1',
                '2.1',
                '3.1',
                '4',
                '5.1',
                '6',
            ],
        },

        scenarioHotspots: {
            drug_enforcement: [
                {
                    ref: "1.1", image: 'drug_enforcement-hotspot-1.1.png',
                    title: 'Ruggedised radio boxes and TactiCall boxes provide a high level of flexibility and scalability.',
                },
                {
                    ref: "1.2", image: 'drug_enforcement-hotspot-1.2.png',
                    title: 'Ruggedised radio boxes and TactiCall boxes provide a high level of flexibility and scalability.',
                },
                {
                    ref: "2.1", image: 'drug_enforcement-hotspot-2.1.png',
                    title: 'Suitable masts and antennas provide support to selected radio systems.',
                },
                {
                    ref: "2.2", image: 'drug_enforcement-hotspot-2.2.png',
                    title: 'Suitable masts and antennas provide support to selected radio systems.',
                },
                {
                    ref: "3.1", image: 'drug_enforcement-hotspot-3.1.png',
                    title: 'Lightweight SatCom equipment provides the necessary global communication capability.',
                },
                {
                    ref: "3.2", image: 'drug_enforcement-hotspot-3.2.png',
                    title: 'Lightweight SatCom equipment provides the necessary global communication capability.',
                },
                {
                    ref: "4", image: 'drug_enforcement-hotspot-4.png',
                    title: 'Lightweight generators provide power for the different system components.',
                },
            ],
            expeditionary: [
                {
                    ref: "1", image: 'expeditionary-hotspot-1.png',
                    title: 'Multispectral camouflage offers superior sensor threat protection for increased survivability.',
                },
                {
                    ref: "2.1", image: 'expeditionary-hotspot-2.1.png',
                    title: 'Ruggedised radio boxes and TactiCall boxes provide a high level of flexibility and scalability.',
                },
                {
                    ref: "2.2", image: 'expeditionary-hotspot-2.2.png',
                    title: 'Ruggedised radio boxes and TactiCall boxes provide a high level of flexibility and scalability.',
                },
                {
                    ref: "3.1", image: 'expeditionary-hotspot-3.1.png',
                    title: 'Suitable masts and antennas provide support to selected radio systems.',
                },
                {
                    ref: "3.2", image: 'expeditionary-hotspot-3.2.png',
                    title: 'Suitable masts and antennas provide support to selected radio systems.',
                },
                {
                    ref: "4", image: 'expeditionary-hotspot-4.png',
                    title: 'Lightweight generators provide power for the different system components.',
                },
                {
                    ref: "5", image: 'expeditionary-hotspot-5.png',
                    title: 'Fibre-optic cables are used throughout the base for maximum performance and durability.',
                },
                {
                    ref: "6.1", image: 'expeditionary-hotspot-6.1.png',
                    title: 'Lightweight SatCom equipment provides the necessary global communication capability.',
                },
                {
                    ref: "6.2", image: 'expeditionary-hotspot-6.2.png',
                    title: 'Lightweight SatCom equipment provides the necessary global communication capability.',
                },
            ],
            military_base: [
                // {
                //     ref: "1.1", image: 'military_base-hotspot-1.1.png',
                //     title: '10&nbsp;ft and 20&nbsp;ft shelters for different purposes are deployed together with tents as required.',
                // },
                {
                    ref: "1.1", image: 'military_base-hotspot-1.2.png',
                    title: '10&nbsp;ft and 20&nbsp;ft shelters for different purposes are deployed together with tents as required.',
                },
                {
                    ref: "2.1", image: 'military_base-hotspot-2.1.png',
                    title: 'Boxed equipment offers superior flexibility and scalability in providing connections in different parts of the base area.',
                },
                {
                    ref: "2.2", image: 'military_base-hotspot-2.2.png',
                    title: 'Boxed equipment offers superior flexibility and scalability in providing connections in different parts of the base area.',
                },
                {
                    ref: "3", image: 'military_base-hotspot-3.png',
                    title: 'Masts and antennas may be integrated into shelters if required.',
                },
                {
                    ref: "4.1", image: 'military_base-hotspot-4.1.png',
                    title: 'Suitable masts and antennas provide support to selected radio systems.',
                },
                {
                    ref: "4.2", image: 'military_base-hotspot-4.2.png',
                    title: 'Suitable masts and antennas provide support to selected radio systems.',
                },
                {
                    ref: "5", image: 'military_base-hotspot-5.png',
                    title: 'Sheltered high-power diesel generators provide power to system components to meet system requirements.',
                },
                {
                    ref: "6", image: 'military_base-hotspot-6.png',
                    title: 'The C2 shelter offers workplaces for C2 personnel in an office-like environment.',
                },
                {
                    ref: "7.1", image: 'military_base-hotspot-7.1.png',
                    title: 'The high-capability SatCom equipment is housed within a 10&nbsp;ft shelter and offers global high-bandwidth communication.',
                },
                {
                    ref: "7.2", image: 'military_base-hotspot-7.2.png',
                    title: 'The high-capability SatCom equipment is housed within a 10&nbsp;ft shelter and offers global high-bandwidth communication.',
                },
            ],
            // military_base: [
                //     {
                //         ref: "1", image: 'military_base-hotspot-1.png',
                //         title: 'High-capability SatCom equipment offers global high-bandwidth communication',
                //     },
                //     {
                //         ref: "2", image: 'military_base-hotspot-2.png',
                //         title: '10ft and 20ft shelters for different purposes are deployed together with tents as required',
                //     },
                //     {
                //         ref: "3", image: 'military_base-hotspot-3.png',
                //         title: 'Masts and antennas may be integrated into shelters if required',
                //     },
                //     {
                //         ref: "4", image: 'military_base-hotspot-4.png',
                //         title: 'Boxed equipment offers superior flexibility and scalability in providing connections in different parts of the base area',
                //     },
                //     {
                //         ref: "5", image: 'military_base-hotspot-5.png',
                //         title: 'Sheltered high-power diesel generators provide power to system components to meet system requirements',
                //     },
                //     {
                //         ref: "6", image: 'military_base-hotspot-6.png',
                //         title: 'Suitable masts and antennas provide support to selected radio systems',
                //     },
                //     {
                //         ref: "7", image: 'military_base-hotspot-7.png',
                //         title: 'The high-capability SatCom equipment is housed within a 10ft shelter',
                //     },
                //     {
                //         ref: "8", image: 'military_base-hotspot-8.png',
                //         title: 'Fibre-optic cables are used throughout the base for maximum performance and durability',
                //     },
                //     {
                //         ref: "9", image: 'military_base-hotspot-9.png',
                //         title: 'The C2 shelter offers workplaces for C2 personnel in an office-like environment',
                //     },
            // ],
            disaster_relief: [
                {
                    ref: "1", image: 'disaster_relief-hotspot-1.png',
                    title: 'Communications equipment for radio, telephony and network are installed in containers with environment control.',
                },
                {
                    ref: "2", image: 'disaster_relief-hotspot-2.png',
                    title: 'The C2 shelter offers workplaces for C2 personnel in an office-like environment.',
                },
                {
                    ref: "3.1", image: 'disaster_relief-hotspot-3.1.png',
                    title: 'Suitable masts and antennas provide support to the selected radio systems.',
                },
                {
                    ref: "3.2", image: 'disaster_relief-hotspot-3.2.png',
                    title: 'Suitable masts and antennas provide support to the selected radio systems.',
                },
                {
                    ref: "4", image: 'disaster_relief-hotspot-4.png',
                    title: 'Sheltered high-power diesel generators provide power to system components to meet system requirements.',
                },
                {
                    ref: "5", image: 'disaster_relief-hotspot-5.png',
                    title: 'High-capability SatCom equipment offers global high-bandwidth communication.',
                },
            ],
            airbase: [
                {
                    ref: "1.1", image: 'airbase-hotspot-1.1.png',
                    title: '10&nbsp;ft and 20&nbsp;ft shelters for communication and C2 together with boxed modules and high-power diesel generators are deployed to meet system requirements.',
                },{
                    ref: "1.2", image: 'airbase-hotspot-1.2.png',
                    title: '10&nbsp;ft and 20&nbsp;ft shelters for communication and C2 together with boxed modules and high-power diesel generators are deployed to meet system requirements.',
                },
                // {
                //     ref: "1.3", image: 'airbase-hotspot-1.3.png',
                //     title: '10&nbsp;ft and 20&nbsp;ft shelters for communication and C2 together with boxed modules and high-power diesel generators are deployed to meet system requirements.',
                // },
                {
                    ref: "1.3", image: 'airbase-hotspot-1.4.png',
                    title: '10&nbsp;ft and 20&nbsp;ft shelters for communication and C2 together with boxed modules and high-power diesel generators are deployed to meet system requirements.',
                },{
                    ref: "1.4", image: 'airbase-hotspot-1.5.png',
                    title: '10&nbsp;ft and 20&nbsp;ft shelters for communication and C2 together with boxed modules and high-power diesel generators are deployed to meet system requirements.',
                },{
                    ref: "2.1", image: 'airbase-hotspot-2.1.png',
                    title: 'Suitable masts and antennas to support the selected radio systems.',
                },{
                    ref: "2.2", image: 'airbase-hotspot-2.2.png',
                    title: 'Suitable masts and antennas to support the selected radio systems.',
                },{
                    ref: "3.1", image: 'airbase-hotspot-3.1.png',
                    title: 'Shelters and man-carried boxes are deployed as required, and fibre-optic cables are used to connect deployed equipment.',
                },{
                    ref: "3.2", image: 'airbase-hotspot-3.2.png',
                    title: 'Shelters and man-carried boxes are deployed as required, and fibre-optic cables are used to connect deployed equipment.',
                },{
                    ref: "3.3", image: 'airbase-hotspot-3.3.png',
                    title: 'Shelters and man-carried boxes are deployed as required, and fibre-optic cables are used to connect deployed equipment.',
                },{
                    ref: "4", image: 'airbase-hotspot-4.png',
                    title: 'Mobile ATC Tower module for specific airbase requirements.',
                },{
                    ref: "5.1", image: 'airbase-hotspot-5.1.png',
                    title: 'Flexibility in deployment allows for a technically sound placement of equipment with a tactical dispersion.',
                },{
                    ref: "5.2", image: 'airbase-hotspot-5.2.png',
                    title: 'Flexibility in deployment allows for a technically sound placement of equipment with a tactical dispersion.',
                },{
                    ref: "6", image: 'airbase-hotspot-6.png',
                    title: 'Deployable Aircraft Maintenance Facility (DAM) provides shelter for aircraft and land vehicles.',
                },
            ],
        },
    },

    methods: {
        calcIDs() {
            var url_test = this.$route.fullPath.split('/')
            return {
                scenario: url_test[url_test.length - 2].replace('-', '_'),
                stage: url_test[url_test.length - 1].replace('-', '_'),
            }
        },
        deploy() {
            this.$router.push('stage-1')
        },
        handleSplashKeys(e) {
            switch (e.keyCode) {
                case 13: // return/enter
                case 39: // right
                    this.deploy()
                break;
            }
        },
        formatForSequenceStart(url) {
            return url.replace('_', '-').replace(/.$/, '1')
        },
        formatForAutoChange(url) {
            var current = parseInt(url.substr(url.length - 1))
            return url.replace('_', '-').replace(/.$/, current + 1)
        },

        resetBackgroundFader(fader) {
            fader.reset()
        },


        toggleFullscreen(elem) {
            elem = elem || document.documentElement;
            if (!document.fullscreenElement && !document.mozFullScreenElement &&
                !document.webkitFullscreenElement && !document.msFullscreenElement) {
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.msRequestFullscreen) {
                    elem.msRequestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) {
                    elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            }
        },
    },

    computed: {
        viewWindowBinding() {
            return {'height': this.viewWindow.height, 'width': this.viewWindow.width}
        },
        is_nwjs() {
            try{
                return (typeof require('nw.gui') !== "undefined");
            } catch (e){
                return false;
            }
        },
    },
}

export default dataStore